import uirouter from '@uirouter/angularjs';
import vcRecaptcha from 'angular-recaptcha';
import NetverifyService from './services/netverify.ts';

import common from 'app/modules/common';

export default angular
  .module('app.holding.dashboard.onboarding', [
    common,
    uirouter,
    vcRecaptcha,
  ])
  .service('GmwNetVerify', NetverifyService)
  .name;

require('./controllers/setup/routing');
require('./controllers/sign-up/routing');
require('./directives/date-selector/date-selector');
require('./directives/box-phone-selector/box-phone-selector');
require('./directives/contact-info-form/contact-info-form');
require('./directives/employment-selector/employment-selector');
require('./directives/fatca-selector/fatca-selector');
require('./directives/gender-toggle/gender-toggle');
require('./directives/id-selector/id-selector');
require('./directives/onboarding-header/onboarding-header');
require('./directives/review-row/review-row');
require('./directives/sign-in-hero/sign-in-hero');
require('./directives/source-of-funds/source-of-funds');
require('./directives/title-toggle/title-toggle');
require('./directives/validate-password/validate-password');
require('./directives/verification-requirement/verification-requirement');
require('./directives/verification-step/verification-step');
require('./services/setup');
require('./services/security-questions');
require('./services/sign-up');



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/onboarding/index.js